import axios from 'axios'

export const getProfileData = async token => {
  const url = process.env.GATSBY_API_LOYALTY_APP

  const headers = {
    Authorization: `Bearer ${token}`,
    'x-functions-key': process.env.GATSBY_AZURE_FUNCTION_KEY,
    'Access-Control-Allow-Origin': '*'
  }
  const params = { op: 'getProfileData' }

  const res = await axios({
    method: 'get',
    headers,
    url,
    params
  })

  return res.data
}
